export default __webpack_public_path__ + "static/media/Emerald.271d5924.png";